import { addRoomsToBeConnected, addToCheckoutCart, removeRoomsToBeConnected } from 'actions/CheckoutActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import React, { ComponentProps, useCallback } from 'react'
import MultiRoomOfferCheckoutButton from './MultiRoomOfferCheckoutButton'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import TextButton from 'LuxKit/Button/TextButton'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { isAccommodationItem } from 'lib/checkout/checkoutUtils'
import { getActivePackagesByRoom, PackageOptionViewByRoom } from 'selectors/offerPage/multipleRoomBookingSelectors'

interface Props extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'children'> {
  disabled?: boolean;
  checkIn?: string;
  rooms: Array<App.RoomOccupants>;
  activePackagesByRoom: PackageOptionViewByRoom;
}

function MultiRoomOfferBookButton(props: Props) {
  const { disabled, checkIn, rooms, activePackagesByRoom, ...rest } = props
  const dispatch = useAppDispatch()

  const goToCheckout = useCallback((items: Array<App.Checkout.AnyItem>, connectRooms: boolean, keepBrowsing: boolean) => {
    const offerId = items.find(isAccommodationItem)!.offerId
    dispatch(addToCheckoutCart(items))
    if (connectRooms) {
      dispatch(addRoomsToBeConnected(offerId))
    } else {
      dispatch(removeRoomsToBeConnected(offerId))
    }
    if (keepBrowsing) {
      showSnackbar('Your item has been added to the cart.', 'success', { action: { label: 'View cart', to: '/cart' } })
      return
    }
    dispatch(navigateToCheckout())
  }, [dispatch])

  return <MultiRoomOfferCheckoutButton
    {...rest}
    activePackagesByRoom={activePackagesByRoom}
    kind="primary"
    type="submit"
    onProceedToBooking={goToCheckout}
    disabled={disabled}
  >
    {checkIn ? `Book ${rooms.length} rooms now` : 'Check availability'}
  </MultiRoomOfferCheckoutButton>
}

export default withOfferPageAndReduxState((state, appState) => ({
  checkIn: state.checkInDate,
  rooms: state.rooms,
  activePackagesByRoom: getActivePackagesByRoom(state, appState),
}), MultiRoomOfferBookButton)
